export * from './courseDetailsMapper';
